// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AudioCompletionController from "./audio_completion_controller.js"
application.register("audio-completion", AudioCompletionController)

import CapacityEventController from "./capacity_event_controller.js"
application.register("capacity-event", CapacityEventController)

import ChatController from "./chat_controller.js"
application.register("chat", ChatController)

import ClientHappinessFormController from "./client_happiness_form_controller.js"
application.register("client-happiness-form", ClientHappinessFormController)

import CoachesForSubjectController from "./coaches_for_subject_controller.js"
application.register("coaches-for-subject", CoachesForSubjectController)

import CommentController from "./comment_controller.js"
application.register("comment", CommentController)

import CorrectionRatingsController from "./correction_ratings_controller.js"
application.register("correction-ratings", CorrectionRatingsController)

import CorrectionsController from "./corrections_controller.js"
application.register("corrections", CorrectionsController)

import DaterangeController from "./daterange_controller.js"
application.register("daterange", DaterangeController)

import DropdownController from "./dropdown_controller.js"
application.register("dropdown", DropdownController)

import EmojiPickerController from "./emoji_picker_controller.js"
application.register("emoji-picker", EmojiPickerController)

import FileController from "./file_controller.js"
application.register("file", FileController)

import FlatpickrController from "./flatpickr_controller.js"
application.register("flatpickr", FlatpickrController)

import ForecastDemandController from "./forecast_demand_controller.js"
application.register("forecast-demand", ForecastDemandController)

import NotificationController from "./notification_controller.js"
application.register("notification", NotificationController)

import OverlayController from "./overlay_controller.js"
application.register("overlay", OverlayController)

import RatingValidatorController from "./rating_validator_controller.js"
application.register("rating-validator", RatingValidatorController)

import RefreshController from "./refresh_controller.js"
application.register("refresh", RefreshController)

import RenameCorrectionController from "./rename_correction_controller.js"
application.register("rename-correction", RenameCorrectionController)

import Select2Controller from "./select2_controller.js"
application.register("select2", Select2Controller)

import SubmitOnChangeController from "./submit_on_change_controller.js"
application.register("submit-on-change", SubmitOnChangeController)

import TermFormController from "./term_form_controller.js"
application.register("term-form", TermFormController)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)

import TomSelectController from "./tom_select_controller.js"
application.register("tom-select", TomSelectController)

import ValidationsController from "./validations_controller.js"
application.register("validations", ValidationsController)

import VideoController from "./video_controller.js"
application.register("video", VideoController)

import WorkFeatureController from "./work_feature_controller.js"
application.register("work-feature", WorkFeatureController)

import CoachingDashboardController from "./coaching_dashboard_controller.js"
application.register("coaching-dashboard", CoachingDashboardController)

import ColumnLoaderController from "./column_loader_controller.js"
application.register("column-loader", ColumnLoaderController)

import StatusSelectController from "./status_select_controller"
application.register("status-select", StatusSelectController)
